import type { SupporterVoice } from '#src/app/pages/actions/shared/types';

import type { SupporterCommentsQuery } from './getSupporterComments.graphql';

export type GqlSupporterComment = SupporterCommentsQuery['petitionSupporterCommentsConnection']['nodes'][number];

export const gqlSupporterCommentToSupporterVoice = (gqlSupporterComment: GqlSupporterComment): SupporterVoice => ({
	createdAt: gqlSupporterComment.createdAt,
	id: gqlSupporterComment.id,
	text: gqlSupporterComment.textStripped,
	user: gqlSupporterComment.user,
	likeCount: gqlSupporterComment.likeCount,
	viewerLiked: gqlSupporterComment.viewerLiked,
});
